import { Tag } from 'antd';
import { statusColors } from '@/theme';

interface StatusBadgeProps {
  status: string;
  label?: string;
}

const statusLabels: Record<string, string> = {
  PENDING: 'En attente',
  VALIDATED: 'Validé',
  DENIED: 'Refusé',
  NOT_UPLOADED: 'Non téléchargé',
  SECURITY: 'Sécurité',
  INSTALLER: 'Installateur',
  DISTRIBUTOR: 'Distributeur',
  active: 'Actif',
  inactive: 'Inactif',
  suspended: 'Suspendu',
  AWAITING_REGISTRATION: 'En attente d\'inscription',
  DOCUMENTS_PENDING: 'Documents en attente',
  DOCUMENTS_VALIDATED: 'Documents validés',
  OPERATIONAL: 'Opérationnel',
  SUSPENDED: 'Suspendu',
  WAITING_ON_INFORMATION: 'En attente d\'infos',
  REJECTED: 'Refusé',
};

export function StatusBadge({ status, label }: StatusBadgeProps) {
  const color =
    statusColors[status as keyof typeof statusColors] ?? statusColors.NOT_UPLOADED;
  const displayLabel = label ?? statusLabels[status] ?? status;

  return (
    <Tag
      style={{
        backgroundColor: `${color}14`,
        color,
        borderColor: `${color}40`,
        borderRadius: 100,
        fontWeight: 500,
        fontSize: 12,
        padding: '2px 10px',
      }}
    >
      {displayLabel}
    </Tag>
  );
}
